import {
	HeaderWrapperState,
	MenuWrapperState
} from '../../';

export class AppState implements HeaderWrapperState, MenuWrapperState {
	public about		= false
	public filter		= false
	public history	= false
	public iab			= false
	public legend		= false
	public login		= false
	public map			= false
	public more			= false
	public search		= false
	public support	= false
	public terms		= false

	update(state: string): AppState {
		this.about		= state === 'about'
		this.filter		= state === 'filter'
		this.history	= state === 'search'
		this.iab			= state === 'iab'
		this.legend		= state === 'legend'
		this.login		= state === 'login'
		this.map			= state === 'map'
		this.more			= state === 'about' || state === 'more' || state === 'support' || state === 'terms'
		this.search		= state === 'search'
		this.support	= state === 'support'
		this.terms		= state === 'terms'

		return this
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/model/state/appState.ts